import { Box, Chip, FlexBox, Text, Tooltip } from '@dixa/lib-shared-habla';
import { MouseEventHandler } from 'react';

import { AIImproveWritingPromptName } from 'apis/ai';

import { Improvement } from '../editorCopilotDropdownImproveReply.constants';

import styles from './replyImprovementsContainer.module.scss';

export type DisabledImprovement = {
  value: Improvement<AIImproveWritingPromptName>['value'];
  tooltip: string;
};

type ReplyImprovementsContainerProps = {
  /** OnSelect callback for when a user selects a pill */
  onSelect: (value: string) => void;
  /** Array of pills to display */
  improvements: readonly Improvement<AIImproveWritingPromptName>[];
  /** Disable onSelect callback */
  disabled?: boolean;
  /** Array of pills to hide */
  disabledImprovements?: DisabledImprovement[];
};

export const ReplyImprovementsContainer = ({
  onSelect,
  improvements,
  disabled = false,
  disabledImprovements = [],
}: ReplyImprovementsContainerProps): JSX.Element => {
  return (
    <FlexBox flexDirection="row" padding="0 250 0" className={styles.root}>
      <Box flex="1 1 auto" className={styles.improvements}>
        {improvements.map(({ name, icon, value }) => {
          const foundDisabledImprovement = disabledImprovements.find(
            (disabledImprovement) => disabledImprovement.value === value,
          );
          const onClick: MouseEventHandler<HTMLOrSVGElement> = (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (disabled || foundDisabledImprovement) return;
            onSelect(value);
          };
          return (
            <Tooltip
              key={name}
              disabled={!foundDisabledImprovement}
              content={foundDisabledImprovement?.tooltip}
              wrapProps={{ className: styles.tooltip }}
            >
              <Chip
                className={styles.improvement}
                onClick={onClick}
                disabled={!!(disabled || foundDisabledImprovement)}
              >
                <img className={styles.improvementEmoji} src={icon} />
                <Text.Heading variant="heading-4">{name}</Text.Heading>
              </Chip>
            </Tooltip>
          );
        })}
      </Box>
    </FlexBox>
  );
};
